<template>
	<div class="slb-list-container init">
		<div class="cps-page-top">
			<div class="jc-page-header">
				<el-page-header :title="$t('slb.text.slb')" />
				<div class="jc-box-action">
					<a v-bind:href="Config.SLB_HELP_URL" target="_blank">
						{{ $t('slb.text.slbHelpDoc') }}</a>
				</div>
			</div>
			<div class="jc-page-content">
				<div class="jc-container-table">
					<div class="jc-container-table-actionBar flex-display">
						<!--刷新和切换地域-->
						<el-form class="jc-table-actionBar-item" :inline="true">
							<!--刷新-->
							<el-form-item>
								<el-button icon="jc-icon-refresh-line" class="jc-button-icon"
									@click="updateList('refresh')">
								</el-button>
							</el-form-item>
							<!--切换地域-->
							<el-form-item>
								<el-radio-group v-model="region" @change="regionChange">
									<el-radio-button v-for="(area, index) in region_map" :key="index" :label="area.region">
										{{ area.regionName }}
									</el-radio-button>
								</el-radio-group>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="jumpToCreate()">
									{{ $t('listPage.text.create') }}
								</el-button>
							</el-form-item>
						</el-form>
						<el-form class="jc-box-table-search" :inline="true" @submit.native.prevent>
							<!--搜索-->
							<el-form-item>
								<el-input v-entire-placeholder style="height:30px;width:412px"
									@keyup.enter.native="updateList('refresh')" :placeholder="currentPlaceholder"
									v-model="currentSearchValue">
									<el-select slot="prepend" id="my-select" v-model="currentSearch" @change="changeSearch"
										class="my-select-select" :placeholder="$t('listPage.placeholder.choose')">
										<el-option class="my-select-input" v-for="item in searchSelect"
											:key="item.searchValue" :label="item.searchLabel" :value="item.searchValue">
										</el-option>
									</el-select>
									<el-button slot="append" icon="jc-icon-search" class="search-icon"
										@click="updateList('refresh')">
									</el-button>
								</el-input>
							</el-form-item>
							<!-- 筛选标签 -->
							<el-form-item>
								<jcb-tag-filter :service-code="ServiceCodeConstant.CPSLB"
									:visible.sync="batchEditTagDialogVisible" :region-id="region ? region : ''"
									@checkedTags="filterWithCheckedTags">
								</jcb-tag-filter>
							</el-form-item>
							<!--自定义-->
							<el-form-item>
								<el-button icon="el-icon-setting" class="jc-button-icon" @click="customVisible = true"
									style="height:32px;width:32px" :title="$t('listPage.text.customList')">
								</el-button>
							</el-form-item>
							<!--下载-->
							<el-form-item>
								<el-button class="jc-button-icon" icon="jc-icon-download" @click="exportList"
									style="height:32px;width:32px" :title="$t('listPage.text.exportList')">
								</el-button>
							</el-form-item>
						</el-form>

					</div>
					<!--列表数据-->
					<el-table @filter-change="filterChange" :data="tableData" style="width: 100%"
						class="jc-list-table jc-table-header-cell" v-loading="refreshLoading" ref="listTable"
						:empty-text="$t('speechCraft.listEmptyText')">
						<!--ID/实例名称-->
						<el-table-column :label="$t('listPage.tableLabel.idOrName')" min-width="220" key="id"
							v-if="customInfo !== null && customInfo['id'].selected">
							<template slot-scope="scope">
								<el-tooltip class="item" effect="dark" :content="scope.row.loadBalancerId"
									placement="top">
									<span>{{ scope.row.loadBalancerId }}</span>
								</el-tooltip>
								<br />
								<el-tooltip class="item" effect="dark" :content="scope.row.name" placement="top">
									<a href="javascript:void(0)" @click="jumpToDetail(scope.row)">
										{{ scope.row.name }}
									</a>
								</el-tooltip>
							</template>
						</el-table-column>
						<!--可用区-->
						<el-table-column prop="az" min-width="75" key="az" :label="$t('listPage.tableLabel.availableArea')"
							v-if="customInfo !== null && customInfo['az'].selected">
							<template slot-scope="scope">
								<span>{{ $t('eip.text.allAz') }}</span>
							</template>
						</el-table-column>
						<!--状态-->
						<el-table-column prop="status" :label="$t('listPage.tableLabel.status')" min-width="60" key="status"
							:filter-multiple="false" column-key="status" :filters=filterDataStatus
							:filter-method="filterStatus" v-if="customInfo !== null && customInfo['status'].selected">
							<template slot-scope="scope">
								<span v-if="scope.row.statusName === $t('slb.text.active')" :class="statusMap['run']">
									{{ scope.row.statusName }}
								</span>
								<span v-if="scope.row.statusName === $t('slb.text.stopped')" :class="statusMap['shutdown']">
									{{ scope.row.statusName }}
								</span>
							</template>
						</el-table-column>
						<!--网络类型-->
						<el-table-column prop="networkTypeName" min-width="70" key="networkTypeName"
							:label="$t('slb.text.netType')"
							v-if="customInfo !== null && customInfo['networkType'].selected">
							<template slot-scope="scope">
								<span>
									{{ $t('slb.text.publicNet') }}
								</span>
							</template>
						</el-table-column>
						<!--IP版本-->
						<el-table-column prop="ipAddressType" min-width="70" key="ipAddressType"
							:label="$t('slb.text.ipVersion')"
							v-if="customInfo !== null && customInfo['ipVersion'].selected">
							<template slot-scope="scope">
								<span>{{ IpVersionConstant[scope.row.ipAddressType] }}</span>
							</template>
						</el-table-column>
						<!--公网IP-->
						<el-table-column :label="$t('listPage.tableLabel.publicIp')" min-width="90" key="ip"
							v-if="customInfo !== null && customInfo['publicIp'].selected">
							<template slot-scope="scope">
								<p>{{ scope.row.publicIp | maybeEmpty }}</p>
							</template>
						</el-table-column>
						<!--带宽上限-->
						<el-table-column min-width="100" key="bandwidth" prop="bandwidth" :label="$t('slb.text.bandwidth')"
							v-if="customInfo !== null && customInfo['bw'].selected">
							<template slot-scope="scope">
								<span class="english-wrap">
									{{ scope.row.bandwidth ? scope.row.bandwidth + 'Mbps' : '--' }}
								</span>
								<p>
									{{ scope.row.bandwidthPackageId ? $t('eip.text.bandwidthPackage') :
										$t('eip.text.independentBandwidth') }}
								</p>
							</template>
						</el-table-column>
						<!--监听器数量-->
						<el-table-column min-width="75" key="listenerCount" prop="listenerCount"
							:label="$t('slb.text.listenerNumber')"
							v-if="customInfo !== null && customInfo['listenerCounts'].selected">
							<template slot-scope="scope">
								<a href="javascript:void(0)" @click="jumpToListenerDetail(scope.row)">
									{{ scope.row.listenerCount | maybeEmpty }}
								</a>
							</template>
						</el-table-column>
						<!--计费信息-->
						<el-table-column key="charge" min-width="200" :label="$t('listPage.tableLabel.billingInformation')"
							v-if="customInfo !== null && customInfo['billing'].selected">
							<template slot-scope="scope">
								<div v-if="scope.row.expire !== undefined">
									<p>{{ scope.row.chargeModeName }}<span
											v-if="getCheckExpireInfo(scope.row) === 'will-retire'" class="red">{{ '(' +
												$t('listPage.text.hasExpired') + ')' }}</span>
									</p>
                                    <p class="list-expire-p">
                                        {{ scope.row.charge.chargeStartTime + ' ' + $t('listPage.text.created') }}
                                    </p>
									<p v-if="getCheckExpireInfo(scope.row) === 'will-retire' && scope.row.retireTime"
										class="list-expire-p red">{{ scope.row.retireTime + ' ' +
											$t('listPage.text.freed') }}</p>
									<p v-if="getCheckExpireInfo(scope.row) === 'will-expire'" class="list-expire-p red">
										{{ scope.row.expire + ' ' +
											$t('listPage.text.expired') }}</p>
									<p v-if="getCheckExpireInfo(scope.row) === 'available'" class="list-expire-p">
										{{ scope.row.expire + ' ' +
											$t('listPage.text.expired') }}</p>
								</div>
								<div v-else-if="scope.row.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION">
									<p>
										{{ scope.row.chargeModeName }}
										<span v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus)"
											class="expire-warning">
											{{ '(' + $t('privateNetInstance.arrear') + ')' }}
										</span>
									</p>
									<p class="list-expire-p bill-info-tip"
										v-if="scope.row.charge.chargeStatus === 'normal'">
										{{ scope.row.charge.chargeStartTime + ' ' + $t('privateNetInstance.create') }}
									</p>
									<p class="list-expire-p expire-warning"
										v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus) && scope.row.charge.chargeRetireTime">
										{{ scope.row.charge.chargeRetireTime + ' ' + $t('listPage.text.freed') }}
									</p>
								</div>
								<div v-else>
									<span>--</span>
								</div>
							</template>
						</el-table-column>
						<!-- 标签 -->
						<el-table-column :label="$t('listPage.text.tags')" key="tag" :show-overflow-tooltip="true"
							v-if="customInfo !== null && customInfo['tags'].selected" min-width="90"
							class-name="p-line-break">
							<template slot-scope="scope">
								<p>{{ scope.row.tagPairs | maybeEmpty }}</p>
							</template>
						</el-table-column>
						<!--操作-->
						<el-table-column key="operation" min-width="160" :label="$t('listPage.tableLabel.operation')"
							v-if="customInfo !== null && customInfo['operation'].selected">
							<template slot-scope="scope">
								<!--添加监听-->
								<a href="javascript:void(0)" @click="jumpToListenerTab(scope.row)"
									class="cps-select-form-item"
									:class="{ 'cps-dropdown-disabled': !scope.row.chargeStatus || disableByChargeStatus(scope.row) }">
									{{ $t('slb.text.addListener') }}
									<!--无计费信息不支持添加监听-->
									<div class="cps-form-tip" v-if="!scope.row.chargeStatus">
										{{ $t('eip.help.noChargeInfo') }}
									</div>
									<!-- 实例已过期/欠费不支持监听 -->
									<div class="cps-form-tip" v-else-if="disableByChargeStatus(scope.row)">
										{{ $t('privateNetInstance.operations.overdueTip') }}
									</div>
								</a>
								<!--状态未绑定，打开绑定弹性公网IP弹框-->
								<a href="javascript:void(0)" @click="openBindEipDialog(scope.row)"
									v-if="scope.row.publicIp === undefined" class="cps-select-form-item"
									:class="{ 'cps-dropdown-disabled': !scope.row.chargeStatus || disableByChargeStatus(scope.row) }">
									{{ $t('slb.text.bindPublicIp') }}
									<!-- 无计费信息不支持打开 -->
									<div class="cps-form-tip" v-if="!scope.row.chargeStatus">
										{{ $t('eip.help.noChargeInfo') }}
									</div>
									<!-- 实例已过期/欠费不支持打开 -->
									<div class="cps-form-tip" v-else-if="disableByChargeStatus(scope.row)">
										{{ $t('privateNetInstance.operations.overdueTip') }}
									</div>
								</a>
								<!--状态绑定，打开解绑弹性公网IP弹框-->
								<a href="javascript:void(0)" class="cps-select-form-item" @click="selectOpts(SlbOperationConstant.UNBIND, scope.row,
										'unbind',!scope.row.chargeStatus || disableByChargeStatus(scope.row))" v-if="scope.row.publicIp !== undefined"
									:class="{ 'cps-dropdown-disabled': !scope.row.chargeStatus || disableByChargeStatus(scope.row) }">
									{{ $t('eip.text.unbindPublicIp') }}
									<!-- 无计费信息不支持解绑 -->
									<div class="cps-form-tip" v-if="!scope.row.chargeStatus">
										{{ $t('eip.help.noChargeInfo') }}
									</div>
									<!-- 实例已过期/欠费不支持解绑 -->
									<div class="cps-form-tip" v-else-if="disableByChargeStatus(scope.row)">
										{{ $t('privateNetInstance.operations.overdueTip') }}
									</div>
								</a>
								<!--更多-->
								<el-dropdown size="200px">
									<span class="jc-dropdown-link">
										{{ $t('operations.more') }}<i class="jc-icon-caret-bottom jc-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown" class="operation-list-dropdown-menu">
										<!--打开关闭负载均衡操作-->
										<a href="javascript:void(0)"
											@click="selectOpts(SlbOperationConstant.CLOSE, scope.row, 'close', (!scope.row.chargeStatus || disableByChargeStatus(scope.row)))"
											v-if="scope.row.status === 'active'" class="cps-select-form-item"
											:class="{ 'cps-dropdown-disabled': !scope.row.chargeStatus || disableByChargeStatus(scope.row) }">
											<el-dropdown-item :disabled="!scope.row.chargeStatus || disableByChargeStatus(scope.row)">
												{{ $t('slb.text.closed') }}
											</el-dropdown-item>
											<!-- 无计费信息不支持操作 -->
											<div class="cps-form-tip" v-if="!scope.row.chargeStatus">{{
												$t('eip.help.noChargeInfo') }}
											</div>
											<!-- 实例已过期/欠费不支持操作 -->
											<div class="cps-form-tip" v-else-if="disableByChargeStatus(scope.row)">
												{{ $t('privateNetInstance.operations.overdueTip') }}
											</div>
										</a>
										<!--打开开启负载均衡操作-->
										<a href="javascript:void(0)" @click="selectOpts(SlbOperationConstant.OPEN, scope.row, 'open', (!scope.row.chargeStatus || disableByChargeStatus(scope.row) ||
												scope.row.publicIp === undefined))" v-if="scope.row.status === 'inactive'" class="cps-select-form-item"
											:class="{
													'cps-dropdown-disabled': !scope.row.chargeStatus || disableByChargeStatus(scope.row) ||
														scope.row.publicIp === undefined
												}">
											<el-dropdown-item :disabled="!scope.row.chargeStatus || disableByChargeStatus(scope.row) ||
												scope.row.publicIp === undefined">
												{{ $t('slb.text.opened') }}
											</el-dropdown-item>
											<!-- 无计费信息不支持操作 -->
											<div class="cps-form-tip" v-if="!scope.row.chargeStatus">{{
												$t('eip.help.noChargeInfo') }}
											</div>
											<!-- 实例已过期/欠费不支持操作 -->
											<div class="cps-form-tip" v-else-if="disableByChargeStatus(scope.row)">
												{{ $t('privateNetInstance.operations.overdueTip') }}
											</div>
											<div class="cps-form-tip" v-else-if="scope.row.publicIp === undefined">{{
												$t('slb.sentence.bindEipNecessary') }}
											</div>
										</a>
										<!--跳转到续费页面-->
										<a class="cps-select-form-item"
											:class="{ 'cps-dropdown-disabled': !scope.row.chargeStatus }"
											href="javascript:void(0)"
											@click="selectOpts(SlbOperationConstant.RENEW, scope.row, 'renew', !scope.row.chargeStatus)">
											<el-dropdown-item :disabled="!scope.row.chargeStatus">
												{{ $t('operations.renew.name') }}
											</el-dropdown-item>
											<div class="cps-form-tip" v-if="!scope.row.chargeStatus">{{
												$t('eip.help.noChargeInfo') }}
											</div>
										</a>
										<!--编辑标签-->
										<a class="cps-select-form-item"
											:class="{ 'cps-dropdown-disabled': !scope.row.chargeStatus }"
											href="javascript:void(0)"
											@click="selectOpts(SlbOperationConstant.EDITTAG, scope.row, 'editTag', !scope.row.chargeStatus)">
											<el-dropdown-item :disabled="!scope.row.chargeStatus">
												{{ $t('operations.edit_tag.name') }}
											</el-dropdown-item>
											<div class="cps-form-tip" v-if="!scope.row.chargeStatus">{{
												$t('eip.help.noChargeInfo') }}
											</div>
										</a>
										<!--删除slb-->
										<a class="cps-select-form-item"
											:class="{ 'cps-dropdown-disabled': scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION || !scope.row.chargeStatus || scope.row.status === 'active' }"
											href="javascript:void(0)"
											@click="selectOpts(SlbOperationConstant.DELETE, scope.row, 'delete', (scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION || !scope.row.chargeStatus || scope.row.status === 'active'))">
											<el-dropdown-item
												:disabled="scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION || !scope.row.chargeStatus || scope.row.status === 'active'">
												{{ $t('operations.delete.name') }}
											</el-dropdown-item>
											<div class="cps-form-tip" v-if="!scope.row.chargeStatus">{{
												$t('eip.help.noChargeInfo') }}
											</div>
											<div class="cps-form-tip"
												v-else-if="scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION">
												{{ $t('operations.delete.tip') }}
											</div>
										</a>
									</el-dropdown-menu>
								</el-dropdown>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<!--绑定公网IP-->
			<bind-flex-net :visible.sync="bindShow" v-if="bindShow" :region="rowInfo.region"
				:loadBalancerId="rowInfo.loadBalancerId" :instanceName="rowInfo.name" @refresh="updateList('refresh')"
				is-slb="slb">
			</bind-flex-net>
			<!--解绑公网IP-->
			<un-bind-flex-net :visible.sync="unBindShow" :elasticIpId="rowInfo.elasticIpId" :vpcName="rowInfo.name"
				:region="rowInfo.region" :instanceId="rowInfo.instanceId" @refresh="updateList('refresh')">
			</un-bind-flex-net>
			<custom :visible.sync="customVisible" v-if="customVisible" :optionArr="optionArr" :type="type">
			</custom>
			<!-- 编辑标签 -->
			<jcb-tag-edit :visible.sync="editTagDialogVisible" :service-code="ServiceCodeConstant.CPSLB"
				:region-id="rowInfo.region ? rowInfo.region : ''"
				:resource-ids="rowInfo.loadBalancerId ? [rowInfo.loadBalancerId] : []" @complete="updateList('refresh')">
			</jcb-tag-edit>
			<!--删除slb-->
			<delete-slb :visible.sync="deleteSlbVisible" @refresh="updateList('refresh')" :rowInfo="rowInfo"
				:pageSource="'list'">
			</delete-slb>
		</div>
		<div ref="footer" class="cps-page-footer block jc-container-table-actionBar" v-if="total > 0">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
				:page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
import {
	PopStatus,
	NetworkTypeConstant,
	IpVersionConstant,
	SlbOperationConstant,
	ArrearConstantArray,
	OverdueConstantArray,
	ServiceCodeConstant,
	ChargeModeConstant,
} from '@/common/Constants';
import custom from '@/components/common/custom/Custom';
import unBindFlexNet from '@/components/privateNetInstance/bindFlexNet/UnBindFlexNet';
import bindFlexNet from '@/components/privateNetInstance/bindFlexNet/BindFlexNet';
import { operations } from '@/common/SlbPopHelper'
import DeleteSlb from '@/components/common/DeleteSlb';

const statusMap = {
	// 关机
	'shutdown': 'jc-status-warning',
	// 运行
	'run': 'jc-status-success',
	// 未知
	'未知': 'jc-status-danger'
};

const initPage = 1;

export default {
	components: {
		custom,
		unBindFlexNet,
		bindFlexNet,
		DeleteSlb
	},
	name: 'List',
	data() {
		// 模糊搜索条件设置
		const searchSelect = [
			{
				searchValue: 'id',
				searchLabel: this.$t('listPage.text.exampleID')
			},
			{
				searchValue: 'name',
				searchLabel: this.$t('listPage.text.exampleName')
			}
		];
		return {
			PopStatus,
			clientToken: Normal.getClientToken(),
			filters_1: [],
			filters_4: [
				{ text: this.$t('slb.text.active'), value: 'active' },
				{ text: this.$t('slb.text.stopped'), value: 'inactive' },
			],
			chargeModeMap: {
				prepaid_by_duration: this.$t('listPage.text.prepaid_by_duration'),
				postpaid_by_duration: this.$t('listPage.text.postpaid_by_duration')
			},
			statusMap,
			currentPage: initPage,
			form: {},
			region_map: [],
			region: null,
			tableData: [],
			refreshLoading: false,
			regionMap: {},
			idSearch: '',
			nameSearch: '',
			search: 'instanceId',
			// 当前搜索条件
			currentSearch: 'name',
			// 当前搜索input框值
			currentSearchValue: '',
			// 搜索条件下拉选
			searchSelect,
			// 当前搜索条件对应placeholder
			currentPlaceholder: this.$t('list.searchPlaceholder.name'),
			pageSize: 20,
			pageSizes: [20, 50, 100], // 可选每页展示多少条
			total: 0,
			// 自定义列表是否显示
			customVisible: false,
			// 自定义列表表头
			optionArr: [
				{
					// ID/名称
					label: this.$t('listPage.tableLabel.idOrName'),
					value: 'id'
				},
				{
					// 可用区
					label: this.$t('list.region'),
					value: 'az'
				},
				{
					// 状态
					label: this.$t('list.status'),
					value: 'status'
				},
				{
					// 网络类型
					label: this.$t('list.netWorkType'),
					value: 'networkType'
				},
				{
					// IP版本
					label: this.$t('slb.text.ipVersion'),
					value: 'ipVersion'
				},
				{
					// 公网IP
					label: this.$t('listPage.tableLabel.publicIp'),
					value: 'publicIp'
				},

				{
					// 带宽
					label: this.$t('slb.text.bandwidth'),
					value: 'bw'
				},
				{
					// 监听器数量
					label: this.$t('slb.text.listenerNumber'),
					value: 'listenerCounts'
				},
				{
					// 计费信息
					label: this.$t('list.chargeInfo'),
					value: 'billing'
				},
				{
					// 标签
					label: this.$t('listPage.text.tags'),
					value: 'tags'

				},
				{
					// 操作
					label: this.$t('listPage.tableLabel.operation'),
					value: 'operation'
				}
			],
			// 自定义列表类型
			type: 'slbList',
			// 筛选条件
			filterDataStatus: [],
			// 标签过滤后的资源ID
			filteredResourceIds: [],
			status: '',
			// 代替代码中'未知'中文字段
			unknown: this.$t('listPage.text.unknown'),
			// 解绑公网IP弹框是否显示
			unBindShow: false,
			// 绑定公网IP弹框是否显示
			bindShow: false,
			// 当前行数据
			rowInfo: {},
			// 编辑标签组件是否显示
			editTagDialogVisible: false,
			// 批量编辑标签组件是否显示
			batchEditTagDialogVisible: true,
			// 删除slb
			deleteSlbVisible: false
		};
	},
	mounted() {
		this.getRegion();
	},
	created() {
		if (this.$store.state.customInfo[this.type] === null) {
			this.getCustomInfo();
		}
	},
	watch: {
		region(newValue) {
			if (newValue) {
				this.regionChange()
			}
		},
	},
	computed: {
		ServiceCodeConstant: () => ServiceCodeConstant,
		OverdueConstantArray: () => OverdueConstantArray,
		customInfo() {
			return this.$store.state.customInfo[this.type];
		},
		IpVersionConstant: () => {
			return IpVersionConstant
		},
		SlbOperationConstant: () => {
			return SlbOperationConstant
		},
		ArrearConstantArray: () => {
			return ArrearConstantArray
		},
		ChargeModeConstant: () => {
			return ChargeModeConstant
		},
	},
	methods: {
		getRegion() {
			const params = {
				networkType: NetworkTypeConstant.VPC
			};
			Ajax.get('api/cps/getRegions', params).then((res) => {
				const target = this;
				if (res.data) {
					res.data.regions.forEach((region, index) => {
						if (index === 0) {
							if (target.$route.query && target.$route.query.region) {
								target.region = target.$route.query.region;
							} else {
								target.region = region.region;
							}
						}
						const tempFormat = {};
						tempFormat.region = region.region;
						tempFormat.regionName = region.regionName;
						target.region_map.push(tempFormat);
					});
				}
			})
				.catch()
				.finally(() => {
					this.loading = false
				});
		},
		/**
		 **@disc: 确定搜索和导出参数
		 */
		getParamsForSearchAndExport(params) {
			// 搜索部分添加参数
			if (this.currentSearchValue !== '') {
				switch (this.currentSearch) {
					case 'id': {
						params.loadBalancerIds = this.currentSearchValue;
						break;
					}
					case 'name': {
						params.name = this.currentSearchValue;
						break;
					}
				}
			}
			// 状态筛选参数
			if (this.status !== '') {
				params.status = this.status;
			}
		},
		/**
		 **@disc: 获取负载均衡实例数据
		 **@params: none
		 */
		getSlbListData() {
			const target = this;
			// 基础参数
			const param = {
				region: this.region,
				pageNumber: this.currentPage,
				pageSize: this.pageSize,
			};
			if (this.filteredResourceIds.length !== 0) {
				param.loadBalancerIds = this.filteredResourceIds.join(',');
			};
			this.getParamsForSearchAndExport(param)
			Ajax.get('/api/cps/listSlbs', param)
				.then((res) => {
					const data = res.data;
					this.refreshLoading = false;
					const list = data.loadBalancers;
					target.tableData = list;
					target.total = data.totalCount;
					if (list && list.length > 0) {
						for (let i = 0; i < list.length; i++) {
							let az_name = '';
							for (const index in target.filters_1) {
								if (list[i].az === target.filters_1[index].value) {
									az_name = target.filters_1[index].text;
								}
							}
							let statusName = this.intermediate;
							let statusFlag = false;
							for (const loc in target.filters_4) {
								if (list[i].status === target.filters_4[loc].value) {
									statusName = target.filters_4[loc].text;
									statusFlag = true;
								}
							}
							// 如果状态找不到
							if (!statusFlag) {
								statusName = this.unknown,
									list[i].status = 'noOperate';
							}
							// 格式化显示字段
							list[i].chargeModeName = target.chargeModeMap[list[i].charge.chargeMode];
							list[i].chargeMode = list[i].charge.chargeMode;
							list[i].statusName = statusName;
							list[i].chargeDesc = target.chargeModeMap[list[i].charge.chargeMode];
							list[i].expire = list[i].charge.chargeExpiredTime;
							list[i].chargeStatus = list[i].charge.chargeStatus;
							list[i].tagPairs = '';
							if (list[i].tags !== undefined && list[i].tags.length > 0) {
								for (const tag of list[i].tags) {
									list[i].tagPairs += `${tag.key}:${tag.value},`;
								}
								list[i].tagPairs = list[i].tagPairs.substring(0, list[i].tagPairs.length - 1);
							}
							if (typeof list[i].charge.chargeRetireTime !== 'undefined') {
								list[i].retireTime = list[i].charge.chargeRetireTime;
							}
						}
					}
				}
				)
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						target.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				})
				.finally(() => {
					this.refreshLoading = false;
				}
				)
		},
		updateList(type) {
			// 筛选暂时前端筛选  后面量大改为后端
			if (type === 'refresh') {
				this.refreshLoading = true;
				this.currentPage = 1;
				this.nameSearch = '';
				this.idSearch = '';
			}
			this.getSlbListData();
		},
		filterWithCheckedTags(filterTags, tagKeys, resourceIds) {
			if (tagKeys.length !== 0) {
				this.filteredResourceIds = resourceIds;
			} else {
				this.filteredResourceIds = [];
			}
			this.updateList();
		},
		// 选择地区
		regionChange() {
			this.$refs.listTable.clearFilter();
			this.status = '';
			this.currentSearchValue = '';
			this.currentPage = initPage;
			this.getFilterLists();
			this.updateList('refresh');
		},
		filterStatus(value, row) {
			if (row.status === value) {
				this.status = row.status;
				return true;
			}
			return false;
		},
		jumpToDetail(row) {
			this.$router.push({
				name: 'SlbDetail',
				query: {
					activeTabName: 'baseInfo',
					region: row.region,
					loadBalancerId: row.loadBalancerId
				}
			});
		},
		// 跳转到监听器详情
		jumpToListenerDetail(row) {
			this.$router.push({
				path: `/lb/detail`,
				query: {
					loadBalancerId: row.loadBalancerId,
					region: this.region,
					activeTabName: 'listenerList'
				}
			});
		},
		jumpToCreate() {
			this.$router.push({
				name: 'SlbCreate',
				query: { region: this.region }
			});
		},
		/**
		 * 判断当前时间与到期、释放时间关系
		 * @param row
		 * @return {string}
		 */
		getCheckExpireInfo(row) {
			if (row.charge.chargeExpiredTime !== undefined) {
				const now = Date.now();
				const expire = (new Date(row.charge.chargeExpiredTime)).getTime();
				const DAYS = 1000 * 60 * 60 * 24;
				if (now > expire && row.charge.chargeRetireTime) {
					return 'will-retire';
				}
				if (expire - now > 7 * DAYS) {
					return 'available';
				}
				return 'will-expire';
			}
		},
		// 判断操作是否应该因不正确的计费状态而被禁用
		disableByChargeStatus(row) {
			if (OverdueConstantArray.includes(row.charge.chargeStatus)) {
				return true;
			}
			return false;
		},
		// 修改搜索条件
		changeSearch() {
			const searchPlaceholder = this.$t('list.searchPlaceholder');
			const currentSearchVar = this.currentSearch;
			this.currentPlaceholder = searchPlaceholder[currentSearchVar];
			// 清空当前搜索条件
			this.currentSearchValue = '';
		},
		// 导出列表接口
		exportList() {
			const target = this;
			const params = {
				pageSize: target.pageSize,
				pageNumber: target.currentPage,
				region: target.region,
			};
			this.getParamsForSearchAndExport(params)
			Ajax.download('GET', '/api/export/listSlbs', params, { baseURL: '/cps_api' });
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.currentPage = 1;
			this.updateList('refresh');
		},
		handleCurrentChange(val) {
			this.currentPage = val;
			this.updateList();
		},
		getCustomInfo() {
			const param = {
				pageKey: this.type
			};
			Ajax.get({
				url: '/api/usercenter',
				action: '/getCustomInfo',
				param,
				success: (data) => {
					if (data.customInfo) {
						this.$store.commit('GET_CUSTOMINFO', { value: data.customInfo, type: this.type });
					}
				}
			});
		},
		getFilterLists() {
			const target = this;
			const param = {
				region: this.region,
				networkType: NetworkTypeConstant.BASIC
			};
			Ajax.get({
				url: '/api/filter',
				action: '/listSlbs',
				param,
				success: (data) => {
					if (data) {
						const filterObj = {};
						for (const key in data) {
							filterObj[key] = [];
							for (const sonKey in data[key]) {
								const obj = {
									text: data[key][sonKey],
									value: sonKey
								};
								filterObj[key].push(obj);
							}
						}
						target.filterDataStatus = filterObj.status;
						target.filterDataAzs = filterObj.azs;
						target.filterDataDeviceTypes = filterObj.deviceTypes;
					}
				}
			});
		},
		filterChange(filter) {
			this.currentPage = 1;
			for (const key in filter) {
				switch (key) {
					case 'status': {
						this.status = filter[key][0]
						break;
					}
				}
			}
			this.getSlbListData();
		},
		// 打开绑定公网IP弹框
		openBindEipDialog(rowInfo) {
			if (!rowInfo.chargeStatus || this.disableByChargeStatus(rowInfo)) {
				return false;
			}
			this.rowInfo = rowInfo;
			this.bindShow = true;
		},
		// 更多中的操作
		selectOpts(caseOps, cps, operate, disabled, otherDisabled) {
			if (disabled || otherDisabled) {
				return;
			}

			switch (caseOps) {
				case SlbOperationConstant.OPEN:
				case SlbOperationConstant.UNBIND:
				case SlbOperationConstant.CLOSE:
				case SlbOperationConstant.RENEW:
				case SlbOperationConstant.EDITTAG:
				case SlbOperationConstant.DELETE: {
					operations(caseOps, this, cps, 'list');
					break;
				}
				default:
			}
		},
		// 跳转到监听器TAB
		jumpToListenerTab(row) {
			if (!row.chargeStatus || this.disableByChargeStatus(row)) {
				return false;
			}
			this.$router.push({
				name: 'SlbDetail',
				query: {
					activeTabName: 'listenerList',
					region: row.region,
					loadBalancerId: row.loadBalancerId
				}
			});
		}
	}
};
</script>


<style lang="scss">
@import '~@/assets/scss/listComon';
@import '~@/assets/scss/paginationCommon';
@import '~@/assets/scss/sliderCommon';
@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/slb/list/List.vue